










































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import SpectrumDiagram from '@c/diagrams/SpectrumDiagram.vue';
import {IndexInterval} from '@u/indexInterval';
import {ComparedDiagramData, DiagramData, DiagramSettings, Freqband} from '@/interfaces/diagrams';
import Loading from '@c/controls/Loading.vue';
import userSettingsStoreModule from '@/store/modules/userSettingsModule';
import {SpectrumEventType, SpectrumYAxisType} from '@/enums/diagrams';
import {SpectrumDiagramData} from './interfaces';
import {getYAxisName} from './utils';
import {getApiStoreSpectrum} from './utils';
import {PMSettings} from '@/views/administration/users/interfaces';
import {addScpectrSubscription} from '@/utils/socketUtils';

const getDiagramSubscriptionParams = (diagram: SpectrumDiagramData) => ({
  moduleType: diagram.moduleType,
  moduleGUID: diagram.moduleGUID,
  eventType: diagram.measurement.eventType,
  spectrumType: diagram.measurement.spectrumType,
});

@Component({
  components: {
    SpectrumDiagram,
    Loading,
  },
})
export default class SpectrumDiagramBox extends Vue {
  // Диаграмма
  @Prop({required: true})
  diagram!: SpectrumDiagramData;

  // timestamp для загрузки спектра
  @Prop({required: false})
  propTimestamp!: number;

  @Prop({required: false, default: false})
  allowComparison!: boolean;

  // Показатель живого обновления
  @Prop({required: false, default: true})
  propLiveUpdateStatus!: boolean;

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  // Список диаграмм для сравнения
  @Prop({required: false, default: null})
  comparedDiagrams!: SpectrumDiagramData[] | null;

  // Значение оси Y заданное в вибродиагностике для спектров с виброскоростью и виброускорением
  @Prop({required: false})
  vibrationSpectrumYAxisType!: SpectrumYAxisType;

  // Флаг сохранения настроек, если false, храним настройки во временной области localstorage
  @Prop({required: false, default: true})
  saveSettings!: boolean;

  @Prop({required: false})
  freqbands!: Freqband[];

  @Prop({required: false})
  span_nodes!: any;

  // Данные графика
  data: ComparedDiagramData = {
    mainDiagram: {data: [], yAxis: {name: '', units: ''}, name: '', id: '', visible: true},
    comparedDiagrams: [],
    spectrumType: SpectrumEventType.Low,
  };

  chartData: DiagramData = {
    data: [],
    yAxis: {name: '', units: ''},
    name: '',
    id: '',
    visible: true,
  };

  comparedChartsData: DiagramData[] = [];

  leftX = 0;
  rightX = 0;
  dataLength = 0;

  // Текущая дата спектра
  currentTimestamp: any = null;

  // Переменная для отслеживания изменения сравниваемых графиков
  changedComparedCharts = 0;

  // Показатели загрузки данных и ошибки загрузки данных
  loading = false;
  error = false;

  spectrumYAxisType: SpectrumYAxisType = SpectrumYAxisType.VDecibels;

  spectrumTimeString = '';

  // Обновлять данные
  liveUpdateStatus = this.propLiveUpdateStatus;

  //цвет графика из сохраненных настроек если есть
  color = '';

  isYLogAxis = false;

  hideZeroFrequency: boolean | null = null;

  // Сохранённая частота
  freqband: Freqband | null | undefined = null;

  shouldSaveSettings = this.saveSettings;

  // Минимальное значение масштаба по оси X
  xMinScaleValue = 1;

  // Соединение с веб сокетом
  connectionWS: {diagram: SpectrumDiagramData; socket: WebSocket} | null = null;

  // Соединения с веб сокетом для связанных графиков
  comparedConnectionWS: {diagram: SpectrumDiagramData; socket: WebSocket}[] | null = null;

  // Данные примененного зума
  zoomData: {offset: number; length: number} | null = null;

  // Показатель того, что применен зум
  isInZoom = false;

  @Watch('propTimestamp')
  async changePropTimestamp(value: number) {
    if (this.propTimestamp && !this.currentTimestamp) {
      this.currentTimestamp = value;
    }
    await this.defineInitialChartState(value);
  }

  @Watch('currentTimestamp')
  async changeTimestamp(value: number) {
    if (value) {
      const updateDate = new Date(value);
      this.spectrumTimeString = updateDate ? updateDate.toLocaleString() : '';
    } else {
      this.spectrumTimeString = '';
    }
  }

  @Watch('vibrationSpectrumYAxisType', {immediate: true})
  onChangeVibrationSpectrumYAxisType(newVal: SpectrumYAxisType) {
    if (newVal) this.spectrumYAxisType = newVal;
  }

  @Watch('comparedDiagrams')
  async onChangeComparedDiagrams(
    comparedDiagrams: SpectrumDiagramData[] | null,
    oldComparedDiagrams: SpectrumDiagramData[] | null,
  ) {
    try {
      this.loading = true;
      this.error = false;
      //удаляем подписки для старых диаграмм, нам они уже не нужны
      this.removeWSSubscriptionsForDiagrams(oldComparedDiagrams);
      //удаляем для текущих диаграм
      this.removeWSSubscriptions();
      const comparedData = await this.requestComparedChartsConfigData();
      this.defineComparedCharts(comparedData);
      this.setData();
      this.changedComparedCharts++;
      if (this.liveUpdateStatus) this.addWSSubscriptions();
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  addToCompare() {
    this.$emit('addToCompare', this.diagram, this.currentTimestamp, this.freqbands);
  }

  async changeYAxisType(params: {value: SpectrumYAxisType; recalc: boolean}) {
    this.spectrumYAxisType = params.value;

    if (!params.recalc) return;

    try {
      this.loading = true;
      this.setDiagrams();
    } catch (e) {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  //данные для сравниваемых графиков
  defineComparedCharts(data: any[] | null) {
    if (!data) return;
    this.comparedChartsData = data;
  }

  async created() {
    this.color = this.diagram.color ?? '';
    if (this.diagram.isYLogAxis !== undefined) {
      this.isYLogAxis = this.diagram.isYLogAxis;
    }
    if (this.diagram.hideZeroFrequency !== undefined && this.diagram.hideZeroFrequency !== null) {
      this.hideZeroFrequency = this.diagram.hideZeroFrequency;
    }
    if (this.diagram.freqbandId) {
      this.freqband = this.freqbands.find(freqband => freqband.id === this.diagram.freqbandId);
    }
    await this.defineInitialChartState(this.propTimestamp);
  }

  //Обработчик события изменения статуса "живого" обновления
  async onLiveUpdateStatusChanged(status: boolean) {
    if (!this.propLiveUpdateStatus) return;
    this.liveUpdateStatus = status;
    //обновляем график целиком
    if (status) this.defineInitialChartState(this.propTimestamp);
    else this.removeWSSubscriptions();
  }

  // Метод установки начального состояния графика
  async defineInitialChartState(timestampValue: number) {
    try {
      await this.setDiagrams(timestampValue);
      this.zoomData = null;
      this.changedComparedCharts++;
      if (this.liveUpdateStatus) this.addWSSubscriptions();
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // Действия при зуме графика
  async onChartZoom(indexInterval: IndexInterval) {
    this.isInZoom = true;
    this.removeWSSubscriptions();
    const indexDiff = indexInterval.endIndex - indexInterval.startIndex + 1;
    try {
      this.zoomData = {offset: indexInterval.startIndex + 1, length: indexDiff};
      await this.setDiagrams();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // Действия при выборе новой настройки центральной частоты и ширины полосы для трехосного спектра огибающей dtcp-акселерометра
  async changeFreqband(freqband: Freqband) {
    this.freqband = freqband;
    try {
      this.setDiagrams();
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async setDiagrams(timestampValue: number | null = null) {
    this.error = false;
    this.loading = true;
    const {timestamp, spectrum, leftX, rightX, dataLength} = await getApiStoreSpectrum(
      this.diagram.moduleType,
    ).getSpectrum({
      id: this.diagram.moduleId,
      spectrumType: this.diagram.measurement.spectrumType,
      offset: this.zoomData?.offset,
      length: this.zoomData?.length,
      date: timestampValue ? timestampValue : this.currentTimestamp,
      spectrumValueType: this.spectrumYAxisType,
      fieldAlias: this.diagram.measurement.alias,
      central_frequency: this.freqband?.central_frequency,
      bandwidth: this.freqband?.bandwidth,
    });
    if (timestamp) this.currentTimestamp = timestamp;

    this.leftX = leftX;
    this.rightX = rightX;
    this.dataLength = dataLength;

    const comparedData = await this.requestComparedChartsConfigData();
    this.chartData = {
      data: spectrum,
      yAxis: {
        name: getYAxisName(this.diagram),
        units: this.diagram.measurement.unit != '-' ? this.diagram.measurement.unit : '',
      },
      name: this.diagram.name ? this.diagram.name : '',
      id: this.diagram.id,
      visible: true,
    };
    this.defineComparedCharts(comparedData);
    this.setData();
    this.loading = false;
  }

  // Действие при сбросе зума
  async returnInitialStateChart() {
    if (this.isInZoom) {
      this.isInZoom = false;
      this.zoomData = null;
      this.defineInitialChartState(this.propTimestamp);
    }
  }

  //Запрос данных связанных графиков (TODO: лучше сделать методом на сервере)
  async requestComparedChartsConfigData() {
    if (!this.comparedDiagrams) return null;

    const comparedChartsData: DiagramData[] = [];
    for (let i = 0; i < this.comparedDiagrams.length; ++i) {
      const diagram = this.comparedDiagrams[i];
      const {spectrum, leftX, rightX, dataLength, timestamp} = this.zoomData
        ? await getApiStoreSpectrum(diagram.moduleType).getSpectrum({
            id: diagram.moduleId,
            spectrumType: diagram.measurement.spectrumType,
            offset: this.zoomData?.offset,
            length: this.zoomData?.length,
            date: this.currentTimestamp,
            spectrumValueType: this.spectrumYAxisType,
            fieldAlias: diagram.measurement.alias,
            central_frequency: this.freqband?.central_frequency,
            bandwidth: this.freqband?.bandwidth,
          })
        : await getApiStoreSpectrum(diagram.moduleType).getSpectrum({
            id: diagram.moduleId,
            date: this.currentTimestamp,
            spectrumType: diagram.measurement.spectrumType,
            spectrumValueType: this.spectrumYAxisType,
            fieldAlias: diagram.measurement.alias,
            central_frequency: this.freqband?.central_frequency,
            bandwidth: this.freqband?.bandwidth,
          });

      this.leftX = leftX;
      this.rightX = rightX;
      this.dataLength = dataLength;
      if (timestamp) this.currentTimestamp = timestamp;

      comparedChartsData.push({
        data: spectrum,
        yAxis: {
          name: getYAxisName(diagram),
          units: diagram.measurement.unit != '-' ? this.diagram.measurement.unit : '',
        },
        name: diagram.name ? diagram.name : '',
        id: diagram.id,
        spectrumType: diagram.measurement.spectrumType,
        visible: true,
      });
    }
    return comparedChartsData;
  }

  // Действия при получении данных с веб-сокета
  async subscribeConectionWS(diagram: SpectrumDiagramData, e: {data: string}) {
    const strParse = JSON.parse(e.data);
    if (!strParse) return;

    const {
      timestamp,
      bandwidth,
      central_frequency,
      module_identifier,
      event_type,
      spectrum_type,
    }: {
      timestamp: number;
      bandwidth: number;
      central_frequency: number;
      module_identifier: string;
      event_type: string;
      spectrum_type: string;
    } = strParse;

    const currentTimestamp = new Date().getTime();
    // Если не задан freqband, то запрашиваем спектры для всех
    if (
      module_identifier !== diagram.moduleGUID ||
      event_type !== diagram.measurement.eventType ||
      +spectrum_type !== diagram.measurement.spectrumType ||
      (this.freqband &&
        (central_frequency !== this.freqband.central_frequency ||
          bandwidth !== this.freqband.bandwidth)) ||
      currentTimestamp - timestamp > 60 * 1000
    ) {
      return;
    }
    this.currentTimestamp = timestamp;
    let chartData: any;
    if (diagram.id === this.diagram.id) chartData = this.chartData;
    else {
      if (!this.comparedDiagrams) return;
      chartData = this.comparedChartsData[this.comparedDiagrams.indexOf(diagram)];
    }
    try {
      this.error = false;

      const {
        spectrum,
        leftX,
        rightX,
        dataLength,
        timestamp: timestampSpectrum,
      } = await getApiStoreSpectrum(diagram.moduleType).getSpectrum({
        id: diagram.moduleId,
        date: timestamp,
        spectrumType: diagram.measurement.spectrumType,
        offset: this.zoomData?.offset,
        length: this.zoomData?.length,
        spectrumValueType: this.spectrumYAxisType,
        fieldAlias: diagram.measurement.alias,
        central_frequency: this.freqband?.central_frequency,
        bandwidth: this.freqband?.bandwidth,
      });

      this.leftX = leftX;
      this.rightX = rightX;
      this.dataLength = dataLength;
      if (timestampSpectrum) this.currentTimestamp = timestampSpectrum;

      chartData.data = spectrum;
      this.setData();
    } catch {
      this.error = true;
    }
    //TODO: возможна конкуренция этого метода с обновлением данных при зуме
    // но пока оставил так, т. к. еще не понятно нужно ли обновление при зуме
  }

  setData() {
    this.data = {
      mainDiagram: this.chartData,
      comparedDiagrams: this.comparedChartsData,
      spectrumType: this.diagram.measurement.spectrumType,
    };
  }

  /*Работа с веб-сокетами*/
  // Добавляем подписки
  addWSSubscriptions() {
    if (!this.$dataSocketManager) {
      console.log('No socket manager');
    }

    if (!this.$dataSocketManager.hasSubscription(this.diagram.id)) {
      const params = getDiagramSubscriptionParams(this.diagram);
      const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.spectrumType}/${params.eventType}`;
      const subscriptionFunction = (socket: WebSocket) =>
        addScpectrSubscription.call(this, socket, params);

      this.$dataSocketManager.addSubscription(
        this.diagram.id,
        subscrName,
        subscriptionFunction,
        this.subscribeConectionWS.bind(this, this.diagram),
      );
    }

    //добавляем новые
    this.comparedDiagrams?.forEach(d => {
      if (!this.$dataSocketManager.hasSubscription(d.id)) {
        const params = getDiagramSubscriptionParams(d);
        const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.spectrumType}/${params.eventType}`;
        const subscriptionFunction = (socket: WebSocket) =>
          addScpectrSubscription.call(this, socket, params);

        this.$dataSocketManager.addSubscription(
          d.id,
          subscrName,
          subscriptionFunction,
          this.subscribeConectionWS.bind(this, d),
        );
      }
    });
  }

  // удаляем все подписки
  removeWSSubscriptions() {
    if (!this.$dataSocketManager) {
      console.log('No socket manager');
    }
    this.$dataSocketManager.removeSubscription(this.diagram.id);
    if (this.comparedDiagrams) {
      this.comparedDiagrams.forEach(d => this.$dataSocketManager.removeSubscription(d.id));
    }
  }

  removeWSSubscriptionsForDiagrams(diagrams: SpectrumDiagramData[] | null) {
    if (!this.$dataSocketManager) {
      console.log('No socket manager');
    }
    if (diagrams) {
      diagrams.forEach(d => this.$dataSocketManager.removeSubscription(d.id));
    }
  }
  /**/

  async onUpdateUserSettings(settings: DiagramSettings) {
    const model: PMSettings = {
      pModuleId: this.diagram.moduleId,
      measurementId: this.diagram.measurement.id,
      measurementType: this.diagram.measurement.type,
      color: settings.matchColor,
      freqbandId: settings.freqband?.id,
      isYLogAxis: settings.isYLogAxis,
      hideZeroFrequency: settings.hideZeroFrequency,
    };
    if (this.shouldSaveSettings) {
      // TODO: заменить на сохранение в БД
      await userSettingsStoreModule.saveDiagramSettings(model);
    } else {
      // если не нужно сохранять, то держим настроки в localStore пока используем
      await userSettingsStoreModule.saveTempDiagramSettings(model);
    }
  }

  beforeDestroy() {
    this.removeWSSubscriptions();
  }
}
